import { Observable } from 'rxjs';
import { DeclaracionJurada } from 'src/app/global/interfaces/declaracion-jurada';


export abstract class DeclaracionJuradaServiceVM {

    abstract getDeclaracionJurada(): Observable<DeclaracionJurada>;

    abstract postDeclaracionJurada(): Observable<any>;
}
